<imp-button
  icon="xmark"
  variant="ghost"
  (action)="dismissBanner()" />
<div class="ImproverMobileBanner-contentWrapper">
  <img src="/assets/logo/mobile-logo.svg" />
  <div class="ImproverMobileBanner-mobileAppTextWrapper">
    <span class="ImproverMobileBanner-primaryLabel">{{ 'MOBILE_BANNER_APP_TITLE' | translate }}</span>
    <span class="ImproverMobileBanner-secondaryLabel">{{ 'MOBILE_BANNER_APP_SECONDARY_TEXT' | translate }}</span>
  </div>
</div>
<imp-link-button
  class="ImproverMobileBanner-linkButton"
  label="MOBILE_BANNER_APP_OPEN_BUTTON_LABEL"
  (action)="openApp()" />
